import React, { Fragment, useEffect, useRef, useState } from 'react'
import { Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Pagination from './Pagination';
import SpinningLoader from './SpinningLoader';
import { CSVLink } from 'react-csv';
import Popup from './Popup';

type Props = {
    data?: any,
    loading?: boolean,
    pageNumber?: number,
    totalRecords?: number,
    limit?: number,
    setSearchResult?: (s: string) => void,
    setPageNumber?: (s: number) => void,
    setFilterData?: (s: string) => void,
    setDeleteDr?: (b: boolean) => void,
    deleteDr?: boolean,
    filterData?: string,
    exportDrListData?: any,
    isExport?: boolean,
}

const DrListTable = ({ data, totalRecords = 0, loading, deleteDr = false, setDeleteDr = (b: boolean) => false, setFilterData = (s: string) => "", setSearchResult = (s: string) => "", limit = 8, pageNumber = 1, setPageNumber = (s: number) => 1, filterData, exportDrListData, isExport }: Props) => {

    const refInp = useRef<HTMLInputElement | null>(null);
    const [mrData, setMRData] = useState<any[]>([])
    const [importLoading, setImportLogin] = useState<boolean>(false);
    const [popupToggle, setPopupToggle] = useState<boolean>(false);
    const [drInfo, setDrInfo] = useState<any>({})

    const navigate = useNavigate()

    const addDrClick = () => {
        navigate("/add_doctor")
    }

    useEffect(() => {
        getMRList()
    }, [])

    const getMRList = () => {
        const getMRObj = {
            method: "get_mr_list",
        };
        fetch(`${process.env.REACT_APP_API_URL_MAIN}get_mr_list`, {
            method: "POST",
            headers: {},
            body: JSON.stringify(getMRObj),
        })
            .then((result) => {
                result.json().then((response) => {
                    if (response.status === 1) {
                        setMRData(response?.data.sort((a: any, b: any) =>
                            a.mr_name.localeCompare(b.mr_name)));
                    }
                });
            })
    };

    const editDrClick = (drD: any) => {
        navigate("/edit_doctor", {
            state: drD
        })
    }

    const deleteDrClick = (drI: any) => {
        setPopupToggle(!popupToggle)
        setDrInfo(drI);

    }

    const handleImport = (event: any) => {
        setImportLogin(true)
        event.preventDefault();
        let reader = new FileReader();
        let file = event.target.files[0];
        reader.onloadend = () => {
            const formData = new FormData();
            formData.append("import_doc_data", file);

            fetch(`${process.env.REACT_APP_API_URL_MAIN}import_doc_data`, {
                method: "POST",
                headers: {},
                body: formData,
            })
                .then((result) => {
                    result.json().then((response) => {
                        if (response.status === 1) {
                            setDeleteDr(!deleteDr)
                            setImportLogin(false)
                            toast.success("File imported successfully", {
                                position: "top-center",
                            })
                        }
                        else {
                            toast.error("Action failed !!", {
                                position: "top-center",
                            })
                            setImportLogin(false)
                        }
                    });
                })
                .catch(() => {
                    setImportLogin(false)
                });
        };
        reader.readAsDataURL(file);
    }

    const arr = [{
        "Name": "",
        "City": "",
        "Employee_id": "",
    }]

    const drExpArr = exportDrListData?.map((item: any, index: number) => {
        return (
            {
                "Id": index + 1,
                "Doctor Name": item?.name,
                "City": item?.city,
                "Employee Id": item?.employee_id,
                "MR Name": item?.mr_name,
            }
        )
    })

    return (
        <>
            <div style={{ minHeight: '400px', position: 'relative', marginBottom: '10px', backgroundColor: "#FFFFFF", textAlign: 'left', borderRadius: '10px', boxShadow: '0px 0px 44px #D9EDEF', paddingLeft: '10px', paddingRight: '10px' }} >
                <div className='toolbar d-flex flex-wrap align-items-stretch justify-content-between p-5 '>
                    <h3 style={{ color: '#5B5B5B', paddingTop: '10px' }} >Doctor List</h3>
                    {/* begin::Toolbar container */}
                    <div className='d-flex align-items-stretch flex-wrap pt-3 pt-lg-0'>
                        {/* ---------- search bar ------------- */}
                        <div className='d-flex align-items-center'>
                            <div className='d-flex align-items-center'>
                                <input className='search-input'
                                    onChange={(e) => { setSearchResult(e?.target?.value); setPageNumber(1) }}
                                    placeholder=' search '
                                    style={{ outline: 'none', width: '200px', borderRadius: '8px', border: 'solid #F2F2F2 1px', fontSize: '16px', padding: '8px' }} />
                            </div>
                            <div className='bullet bg-secondary h-35px w-1px mx-5'></div>
                        </div>

                        {/* -------- Add zone ---------- */}
                        <div className='d-flex align-items-center'>
                            <select
                                className='form-select-sm form-select-solid w-100px w-xxl-125px p-3'
                                defaultValue={filterData}
                                onChange={(e) => { setFilterData(e?.target?.value); setPageNumber(1); }}
                            >
                                <option value='' hidden >Filter by MR</option>
                                <option value='' >All</option>
                                {
                                    mrData?.map((item: any, index: number) => {
                                        return (
                                            <option key={index} value={`${item?.employee_id}`} >{item?.mr_name}</option>
                                        )
                                    })
                                }
                            </select>
                            <div className='bullet bg-secondary h-35px w-1px mx-5'></div>
                        </div>
                        <div className='d-flex align-items-center'>
                            <button disabled={importLoading} onClick={() => addDrClick()} className='add-zone-btn' style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: 'max-content', height: 'max-content' }} >+ Add Doctor</button>
                            <div className='bullet bg-secondary h-35px w-1px mx-5'></div>
                        </div>
                        <div className='d-flex align-items-center'>
                            <CSVLink title='It is only use for formate for import data in bulk' data={arr} filename={'template-formate'} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: 'max-content', height: 'max-content' }} >Template For Import Data</CSVLink>
                            <div className='bullet bg-secondary h-35px w-1px mx-5'></div>
                        </div>
                        <div className='d-flex align-items-center'>
                            <button disabled={importLoading} onClick={() => {
                                refInp.current?.click();
                            }} className='add-zone-btn' style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: 'max-content', height: 'max-content' }} > <input onChange={handleImport} hidden type="file" ref={refInp} />Import Data</button>
                            <div className='bullet bg-secondary h-35px w-1px mx-5'></div>
                        </div>
                        <div className='d-flex align-items-center'>
                            {isExport ? <CSVLink data={drExpArr} filename={'doctorData'} style={{ borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', width: 'max-content', height: 'max-content' }} >Export Data</CSVLink> : <div style={{ width: '108px', borderRadius: '8px', backgroundColor: '#0071BB', color: '#ffff', border: 'none', padding: '8px', fontFamily: 'Poppins', fontSize: '16px', height: 'max-content' }}> <SpinningLoader isLoading={!isExport} /> </div>}
                        </div>
                    </div>
                </div>
                {loading || importLoading ?
                    <div style={{ height: '400px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'black' }} >
                        <SpinningLoader
                            isLoading
                        />
                    </div>
                    :
                    data?.length !== 0 ?
                        <>
                            <Table style={{ borderBottom: '1px solid #F2F2F2', textAlign: 'left' }} responsive>
                                <thead style={{ backgroundColor: '#F7F9FA', color: '#878CB9' }} >
                                    <tr>
                                        <th>Dr ID</th>
                                        <th>Dr Name</th>
                                        <th>Dr's City</th>
                                        <th>Edit</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                <tbody style={{ color: 'black' }} >
                                    {
                                        data?.map((item: any, index: number) => {
                                            return (<Fragment key={index}>
                                                <tr>
                                                    <td>{item?.id}</td>
                                                    <td>{item?.name}</td>
                                                    <td>{item?.city}</td>
                                                    <td><img src="./image/Edit.svg" alt="ic" style={{ cursor: "pointer" }} onClick={() => editDrClick(item)} /></td>
                                                    <td><img src="./image/Delete.svg" alt="ic" style={{ cursor: "pointer" }} onClick={() => deleteDrClick(item)} /></td>
                                                </tr>
                                            </Fragment>)
                                        })
                                    }
                                </tbody>
                            </Table>
                        </>
                        : <div className='w-full text-center p-5' ><span style={{ margin: 'auto', textAlign: 'center', color: '#828BA5', fontSize: '1.5rem' }} >No Data Found</span></div>
                }
                {!loading && <div style={{ display: 'flex', paddingBottom: '0px', alignItems: 'center', justifyContent: 'center' }} >
                    {window.location.pathname !== "/admin/dashboard" && <Pagination
                        className="pagination-bar"
                        currentPage={pageNumber}
                        totalCount={totalRecords}
                        pageSize={limit}
                        onPageChange={(page: number) => setPageNumber(page)}
                    />
                    }
                </div>
                }
                {popupToggle && <Popup drInfo={drInfo} onClose={setPopupToggle} setPageNumber={setPageNumber} setDeleteDr={setDeleteDr} deleteDr={deleteDr} />}
            </div>
        </>
    )
}

export default DrListTable